<div class="dots-container d-flex">
  <span
    *ngFor="let _ of levels; let i = index"
    class="dot"
    [class.filled]="level > i"
  ></span>
</div>
